// PT translations for Surplify.
// Maintained as a per-language file. See ../i18n.js for init logic.

const pt = {
  "app.title": "Surplify",
  "nav.home": "Início",
  "nav.search": "Pesquisar",
  "nav.watchlist": "Lista de acompanhamento",
  "nav.requests": "Meus pedidos",
  "nav.dashboard": "Painel",
  "nav.admin": "Admin",
  "nav.import": "Importar",
  "nav.login": "Entrar",
  "nav.register": "Registrar",
  "nav.logout": "Sair",
  "nav.groupRequests": "Pedidos do site",
  "groupRequests.title": "Pedidos recebidos do site",
  "groupRequests.subtitle": "Pedidos dirigidos aos sites do seu grupo",
  "groupRequests.pending": "pendentes",
  "groupRequests.filterAll": "Todos os estados",
  "groupRequests.empty": "Sem pedidos recebidos",
  "groupRequests.emptyHint": "Atualmente não há pedidos dirigidos aos seus sites.",
  "groupRequests.site": "Site destino",
  "material.request": "Solicitar material",
  "material.addToWatchlist": "Adicionar ao acompanhamento",
  "material.removeFromWatchlist": "Remover do acompanhamento",
  "status.available": "Disponível",
  "status.reserved": "Reservado",
  "status.pending": "Pendente",
  "status.approved": "Aprovado",
  "status.rejected": "Rejeitado",
  "status.completed": "Concluído",
  "status.documentation_missing": "Docs faltando",
  "badge.groupOnly": "Só grupo",
  "badge.external": "Externo",
  "badge.slowMoving": "Rotação lenta",
  "badge.nonMoving": "Sem rotação",
  "badge.missingDocs": "Docs faltando",
  "filter.category": "Categoria",
  "filter.site": "Local",
  "filter.age": "Antiguidade",
  "filter.manufacturer": "Fabricante",
  "filter.price": "Preço",
  "filter.width": "Largura",
  "filter.country": "País",
  "filter.allCountries": "Todos os países",
  "common.search": "Pesquisar materiais...",
  "common.loading": "Carregando...",
  "common.noResults": "Nenhum resultado",
  "common.save": "Salvar",
  "common.cancel": "Cancelar",
  "common.submit": "Enviar",
  "common.delete": "Excluir",
  "common.edit": "Editar",
  "common.view": "Ver",
  "common.close": "Fechar",
  "common.back": "Voltar",
  "common.saving": "Salvando...",
  "common.create": "Criar",
  "home.newListings": "Novas listagens",
  "home.highValue": "Stock de alto valor",
  "home.featured": "Materiais em destaque",
  "auth.email": "E-mail",
  "auth.password": "Senha",
  "auth.name": "Nome completo",
  "auth.loginTitle": "Entrar na sua conta",
  "auth.registerTitle": "Criar uma conta",
  "auth.noAccount": "Não tem uma conta?",
  "auth.hasAccount": "Já tem uma conta?",
  "auth.registrationSuccess": "Registro bem-sucedido!",
  "auth.pendingApproval": "Sua conta foi criada e está aguardando a aprovação do administrador.",
  "auth.registerDesc": "Crie uma conta para começar a comercializar materiais",
  "dashboard.totalInventory": "Inventário total",
  "dashboard.slowMoving": "Rotação lenta (>180 dias)",
  "dashboard.nonMoving": "Sem rotação (>360 dias)",
  "dashboard.pendingRequests": "Pedidos pendentes",
  "dashboard.monthlyTransfers": "Transferências mensais",
  "dashboard.overdueItems": "Itens vencidos",
  "dashboard.subtitle": "Visão geral global do inventário",
  "dashboard.siteFilter": "Filtrar por local",
  "dashboard.allSites": "Todos os locais",
  "dashboard.slowMovingDesc": "Materiais de 181-360 dias",
  "dashboard.nonMovingDesc": "Materiais com mais de 360 dias",
  "dashboard.transfersDesc": "Transferências internas este mês",
  "dashboard.overdueDesc": "Itens que precisam de atenção",
  "dashboard.ageChart": "Inventário por antiguidade",
  "dashboard.ageChartDesc": "Distribuição do valor por antiguidade",
  "dashboard.siteRanking": "Ranking de locais",
  "dashboard.siteRankingDesc": "Locais com mais inventário de rotação lenta",
  "dashboard.overdueTitle": "Itens vencidos (>360 dias)",
  "dashboard.overdueDesc2": "Estes itens precisam de atenção imediata",
  "dashboard.viewAllOverdue": "Ver todos os {{count}} itens vencidos",
  "dashboard.viewNonMoving": "Ver stock sem rotação",
  "dashboard.pendingRequestsLink": "Pedidos pendentes",
  "dashboard.importMaterials": "Importar materiais",
  "dashboard.age0_90": "0-90 dias",
  "dashboard.age91_180": "91-180 dias",
  "dashboard.age181_360": "181-360 dias",
  "dashboard.ageGt360": ">360 dias",
  "dashboard.slowMovingItems": "Itens de rotação lenta",
  "dashboard.totalMaterials": "Total de materiais",
  "dashboard.totalMaterialsDesc": "Materiais ativos no inventário",
  "dashboard.externalSales": "Vendas externas",
  "dashboard.externalSalesDesc": "Vendas externas este mês",
  "dashboard.sitePending": "Pedidos pendentes",
  "dashboard.sitePendingDesc": "Pedidos pendentes para este local",
  "import.title": "Importar materiais",
  "import.subtitle": "Importar e exportar dados de materiais via Excel",
  "import.downloadTemplate": "Baixar modelo",
  "import.uploadFile": "Carregar arquivo",
  "import.validate": "Validar",
  "import.execute": "Executar importação",
  "import.mode.overwrite": "Sobrescrever tudo",
  "import.mode.enrich": "Apenas enriquecer",
  "import.mode.selective": "Selecionar campos",
  "import.export": "Exportar",
  "import.exportTitle": "Exportar materiais",
  "import.exportDesc": "Baixar dados de materiais como arquivo Excel com filtros",
  "import.exportDownload": "Baixar Excel",
  "request.title": "Solicitar material",
  "request.quantity": "Quantidade",
  "request.message": "Mensagem (opcional)",
  "request.type.internal": "Transferência interna",
  "request.type.external": "Consulta externa",
  "requests.tab.my": "Meus pedidos",
  "requests.tab.incoming": "Pedidos recebidos",
  "requests.details": "Detalhes do pedido",
  "requests.detail.article": "Artigo",
  "requests.detail.quantity": "Quantidade solicitada",
  "requests.detail.type": "Tipo",
  "requests.detail.requestedBy": "Solicitado por",
  "requests.detail.date": "Data",
  "requests.detail.message": "Mensagem",
  "requests.from": "De",
  "requests.viewDetails": "Ver detalhes",
  "requests.loginRequired": "Login necessário",
  "requests.loginHint": "Entre para ver seus pedidos",
  "requests.empty.my": "Nenhum pedido enviado",
  "requests.empty.myHint": "Você ainda não fez pedidos. Explore materiais e faça um pedido!",
  "requests.empty.incoming": "Nenhum pedido recebido",
  "requests.empty.incomingHint": "Você não tem pedidos recebidos para seus materiais.",
  "requests.action.approve": "Aprovar",
  "requests.action.reject": "Rejeitar",
  "requests.action.complete": "Concluir",
  "requests.action.approveTitle": "Aprovar pedido",
  "requests.action.rejectTitle": "Rejeitar pedido",
  "requests.action.completeTitle": "Concluir pedido",
  "requests.action.approveDesc": "Isto aprovará o pedido e reservará o material.",
  "requests.action.rejectDesc": "Isto rejeitará o pedido.",
  "requests.action.completeDesc": "Isto concluirá a transferência e atualizará o inventário.",
  "requests.action.approvedSuccess": "Pedido aprovado",
  "requests.action.rejectedSuccess": "Pedido rejeitado",
  "requests.action.completedSuccess": "Pedido concluído - inventário atualizado",
  "requests.action.failed": "Falha ao atualizar o pedido",
  "restricted.title": "Conteúdo restrito",
  "restricted.loginHint": "Entre para ver preços, quantidades e localização.",
  "restricted.approvalHint": "Sua conta está aguardando aprovação.",
  "restricted.cardHint": "Entre e obtenha aprovação para ver detalhes",
  "admin.users": "Usuários",
  "admin.usersDesc": "Gerenciar registros e aprovações de usuários",
  "admin.noUsers": "Nenhum usuário encontrado",
  "admin.approved": "Aprovado",
  "admin.pending": "Pendente",
  "admin.registeredAt": "Registrado",
  "admin.approveUser": "Aprovar",
  "admin.revokeUser": "Revogar",
  "admin.userApproved": "Usuário aprovado com sucesso",
  "admin.userRevoked": "Acesso do usuário revogado",
  "admin.userApproveFailed": "Falha ao atualizar o status",
  "admin.deleteUser": "Excluir usuário",
  "admin.deleteUserTitle": "Excluir usuário",
  "admin.deleteUserConfirm": "Tem certeza de que deseja excluir permanentemente o usuário {{name}} ({{email}})? Esta ação não pode ser desfeita.",
  "admin.userDeleted": "Usuário excluído com sucesso",
  "admin.userDeleteFailed": "Falha ao excluir o usuário",
  "admin.categoryTree": "Árvore de categorias",
  "admin.categoryTreeDesc": "Gerenciar categorias de produtos e sua hierarquia",
  "admin.addCategory": "Adicionar categoria",
  "admin.editCategory": "Editar categoria",
  "admin.deleteCategory": "Excluir categoria",
  "admin.addCategoryDesc": "Criar nova categoria de produto",
  "admin.editCategoryDesc": "Editar nome, categoria pai ou ordem",
  "admin.deleteCategoryConfirm": "Tem certeza de que deseja excluir \"{{name}}\"?",
  "admin.categoryName": "Nome da categoria",
  "admin.categoryNamePlaceholder": "ex. Filmes e folhas",
  "admin.parentCategory": "Categoria pai",
  "admin.noParent": "Nenhuma (nível raiz)",
  "admin.sortOrder": "Ordem de classificação",
  "admin.categoryCreated": "Categoria criada",
  "admin.categoryUpdated": "Categoria atualizada",
  "admin.categoryDeleted": "Categoria desativada",
  "admin.categoryCreateFailed": "Falha ao criar categoria",
  "admin.categoryUpdateFailed": "Falha ao atualizar categoria",
  "admin.categoryDeleteFailed": "Falha ao excluir categoria",
  "admin.noCategoriesFound": "Nenhuma categoria encontrada.",
  "admin.delete": "Excluir",
  "create.newTitle": "Publicar material",
  "create.editTitle": "Editar material",
  "create.materialInfo": "Informações do material",
  "create.title": "Título",
  "create.titlePlaceholder": "ex. Filme PE 500mm transparente",
  "create.description": "Descrição",
  "create.descPlaceholder": "Descrição detalhada do material...",
  "create.selectCategory": "Selecionar categoria",
  "create.companyGroup": "Grupo empresarial",
  "create.selectGroup": "Selecionar grupo",
  "create.partNumber": "Número da peça",
  "create.thickness": "Espessura",
  "create.grade": "Grau do material",
  "create.coreDiameter": "Diâmetro do núcleo",
  "create.skuInfo": "Dados de estoque (SKU)",
  "create.addSku": "Adicionar estoque",
  "create.addMore": "Adicionar SKU",
  "create.selectSite": "Selecionar local",
  "create.articleNumber": "Número do artigo",
  "create.rolls": "Número de rolos",
  "create.bookValue": "Valor contábil",
  "create.listPrice": "Preço de lista",
  "create.productionDate": "Data de produção",
  "create.customerSpecific": "Específico do cliente",
  "create.compliant": "Conforme",
  "create.notesInternal": "Notas internas",
  "create.notesInternalPlaceholder": "Visível apenas internamente...",
  "create.publish": "Publicar",
  "create.materialCreated": "Material criado com sucesso",
  "create.materialUpdated": "Material atualizado com sucesso",
  "create.existingSkus": "Estoque existente",
  "create.noNewSkus": "Nenhum novo estoque adicionado",
  "create.previewHint": "Visualização do material",
  "create.untitled": "Material sem título",
  "create.titleRequired": "O título é obrigatório",
  "create.categoryRequired": "A categoria é obrigatória",
  "create.manufacturerRequired": "O fabricante é obrigatório",
  "create.partNumberRequired": "O número da peça é obrigatório",
  "create.groupRequired": "O grupo empresarial é obrigatório",
  "create.siteRequired": "O local é obrigatório",
  "create.articleRequired": "O número do artigo é obrigatório",
  "create.quantityRequired": "A quantidade é obrigatória",
  "create.saveError": "Erro ao salvar o material",
  "watchlist.loginRequired": "Login necessário",
  "watchlist.loginHint": "Entre para ver sua lista de acompanhamento",
  "watchlist.empty": "Sua lista está vazia",
  "watchlist.emptyHint": "Explore materiais e clique no ícone de coração",
  "watchlist.browse": "Explorar materiais",
  "watchlist.remove": "Remover",
  "watchlist.priceOnRequest": "Preço sob consulta",
  "watchlist.addedOn": "Adicionado em",
  "watchlist.itemCount": "{{count}} itens na sua lista",
  "sustainability.title": "Impacto na sustentabilidade",
  "sustainability.subtitle": "Redução de resíduos por redistribuição inteligente",
  "sustainability.heroTagline": "Economia circular para embalagens",
  "sustainability.heroDesc": "Cada material redistribuído é um a menos produzido do zero. Juntos reduzimos CO2, economizamos recursos e construímos um ecossistema de fabricação circular.",
  "sustainability.co2Saved": "CO2 economizado",
  "sustainability.co2SavedDesc": "Emissões evitadas estimadas",
  "sustainability.materialsRedistributed": "Materiais redistribuídos",
  "sustainability.materialsRedistributedDesc": "Transferidos com sucesso entre locais",
  "sustainability.valueSaved": "Valor preservado",
  "sustainability.valueSavedDesc": "Capital de giro economizado",
  "sustainability.activeSites": "Locais ativos",
  "sustainability.activeSitesDesc": "Locais participando da redistribuição",
  "sustainability.circularRate": "Taxa de economia circular",
  "sustainability.circularRateDesc": "Materiais com uma segunda vida",
  "sustainability.atRisk": "Materiais em risco",
  "sustainability.atRiskDesc": "Stock de rotação lenta/nula redistribuível",
  "sustainability.pendingRedist": "Redistribuições pendentes",
  "sustainability.pendingRedistDesc": "Transferências em processamento",
  "sustainability.availableForReuse": "Disponível para reutilização",
  "sustainability.impactBanner": "Juntos prevenimos resíduos de embalagem e economizamos recursos",
  "sustainability.kgUnit": "kg",
  "sustainability.tonUnit": "t",
  "sustainability.downloadReport": "Baixar relatório ESG",
  "sustainability.downloadReportDesc": "Gerar relatório PDF de sustentabilidade",
  "sustainability.reportGenerating": "Gerando relatório...",
  "sustainability.reportReady": "Relatório ESG baixado com sucesso",
  "sustainability.reportError": "Erro ao gerar o relatório",
  "footer.tagline": "Mercado governado para materiais de embalagem excedentes.",
  "footer.marketplace": "Mercado",
  "footer.forPartners": "Para parceiros",
  "footer.support": "Suporte",
  "footer.legalTitle": "Legal",
  "footer.agb": "Termos e condições",
  "footer.impressum": "Aviso legal",
  "footer.datenschutz": "Política de privacidade",
  "footer.datenschutzeinstellungen": "Configurações de privacidade",
  "footer.rights": "Todos os direitos reservados.",
  "nav.standardMaterials": "Materiais padrão",
  "nav.transactions": "Transações",
  "nav.matching": "Material Matching",
  "nav.analytics": "Análises",
  "nav.language": "Idioma",
  "nav.switchGroup": "Mudar grupo",
  "matching.title": "Material Matching",
  "matching.subtitle": "Correspondência automática de excedentes com a demanda de outros locais",
  "matching.refresh": "Atualizar",
  "matching.matches": "Correspondências",
  "matching.matchRate": "Taxa de correspondência",
  "matching.potSavings": "Econ. pot.",
  "matching.sites": "Locais",
  "matching.surplusAvailable": "{{count}} excedentes disponíveis",
  "matching.demandPositions": "{{count}} posições de demanda",
  "matching.matchedQuantity": "{{count}} kg quantidade correspondente",
  "matching.providers": "{{count}} fornecedores",
  "matching.consumers": "{{count}} demandantes",
  "matching.topMaterials": "Materiais mais correspondentes",
  "matching.offerSite": "Local fornecedor",
  "matching.demandSite": "Local demandante",
  "matching.manufacturer": "Fabricante",
  "matching.searchManufacturer": "Pesquisar fabricante...",
  "matching.allSites": "Todos os locais",
  "matching.noMatches": "Sem correspondências",
  "matching.noMatchesDesc": "Não foram encontradas correspondências entre excedentes e listas de demanda.",
  "matching.matchesFound": "{{count}} correspondência(s) encontrada(s)",
  "matching.material": "Material",
  "matching.provider": "Fornecedor",
  "matching.consumer": "Demandante",
  "matching.quantity": "Quantidade",
  "matching.bookValue": "Valor contábil",
  "matching.age": "Antiguidade",
  "matching.width": "Largura",
  "matching.widthFit": "Encaixa",
  "matching.widthDeviation": "Desv.",
  "matching.action": "Ação",
  "matching.view": "Ver",
  "matching.age0_90": "0–90 dias",
  "matching.age91_180": "91–180 dias",
  "matching.age181_360": "181–360 dias",
  "matching.ageGt360": "> 360 dias",
  "analytics.title": "Análises e relatórios",
  "analytics.subtitle": "Análise de tendências, desempenho de locais e avaliações de correspondências",
  "analytics.tabTrends": "Tendências",
  "analytics.tabSites": "Locais",
  "analytics.tabMatching": "Matching",
  "analytics.last6Months": "Últimos 6 meses",
  "analytics.last12Months": "Últimos 12 meses",
  "analytics.last24Months": "Últimos 24 meses",
  "analytics.inventoryTrend": "Evolução do inventário",
  "analytics.inventoryTrendDesc": "Desenvolvimento mensal do número de artigos e valor do inventário",
  "analytics.articles": "Artigos",
  "analytics.valueKEUR": "Valor (kEUR)",
  "analytics.transactionVolume": "Volume de transações",
  "analytics.transactionVolumeDesc": "Transações mensais",
  "analytics.transactions": "Transações",
  "analytics.requestTrend": "Evolução dos pedidos",
  "analytics.requestTrendDesc": "Total vs. pedidos concluídos",
  "analytics.requests": "Pedidos",
  "analytics.completed": "Concluídos",
  "analytics.siteComparison": "Comparação de locais: valor do inventário",
  "analytics.siteComparisonDesc": "Valor total (kEUR) por local",
  "analytics.redistributionRanking": "Ranking de redistribuição",
  "analytics.redistributionRankingDesc": "Redistribuições concluídas por local",
  "analytics.redistributions": "Redistribuições",
  "analytics.openRequests": "Pedidos abertos",
  "analytics.siteDetails": "Detalhes do local",
  "analytics.site": "Local",
  "analytics.value": "Valor (kEUR)",
  "analytics.slowMoving": "Rotação lenta",
  "analytics.redistributed": "Redistribuído",
  "analytics.demand": "Demanda",
  "analytics.noSiteData": "Sem dados de local disponíveis",
  "analytics.kpiMatches": "Correspondências",
  "analytics.kpiMatchRate": "Taxa de correspondência",
  "analytics.kpiMatchedValue": "Valor correspondente",
  "analytics.kpiMaterials": "Materiais",
  "analytics.topMatchedMaterials": "Materiais mais correspondentes",
  "analytics.categoryDistribution": "Correspondências por categoria",
  "analytics.sitePairFlows": "Fluxos de locais (Fornecedor → Demandante)",
  "analytics.sitePairFlowsDesc": "Fluxos de material mais frequentes entre locais",
  "analytics.noData": "Sem dados",
  "analytics.noMatchingData": "Sem dados de correspondência disponíveis",
  "transactions.title": "Transações",
  "transactions.subtitle": "Todas as transações concluídas e abertas",
  "transactions.allStatuses": "Todos os estados",
  "transactions.statusCompleted": "Concluída",
  "transactions.statusCancelled": "Cancelada",
  "transactions.statusPending": "Aberta",
  "transactions.total": "Transações",
  "transactions.completed": "Concluídas",
  "transactions.totalValue": "Valor total",
  "transactions.date": "Data",
  "transactions.material": "Material",
  "transactions.type": "Tipo",
  "transactions.seller": "Vendedor",
  "transactions.buyer": "Comprador",
  "transactions.quantity": "Quantidade",
  "transactions.value": "Valor",
  "transactions.fee": "Taxa",
  "transactions.status": "Estado",
  "transactions.rating": "Avaliação",
  "transactions.internal": "Interno",
  "transactions.external": "Externo",
  "transactions.empty": "Ainda sem transações",
  "transactions.emptyDesc": "As transações são criadas automaticamente ao concluir pedidos.",
  "transactions.rate": "Avaliar",
  "transactions.rated": "Avaliado",
  "transactions.rateTitle": "Avaliar transação",
  "transactions.counterparty": "Contraparte",
  "transactions.unknown": "Desconhecido",
  "transactions.commentLabel": "Comentário (opcional)",
  "transactions.commentPlaceholder": "Como foi a cooperação?",
  "transactions.submitRating": "Enviar avaliação",
  "transactions.submitting": "Enviando...",
  "transactions.ratingSuccess": "Avaliação enviada",
  "transactions.ratingError": "Erro ao enviar avaliação",
  "transactions.ratingRequired": "Avalie pelo menos uma categoria",
  "transactions.loadError": "Erro ao carregar transações",
  "transactions.reviews": "Avaliações",
  "transactions.noReviews": "Ainda sem avaliações.",
  "transactions.comments": "Comentários",
  "transactions.group": "Grupo",
  "transactions.review": "avaliações",
  "notifications.title": "Notificações",
  "notifications.allRead": "Todas lidas",
  "notifications.none": "Sem notificações",
  "notifications.noFiltered": "Sem notificações correspondentes",
  "notifications.filterAll": "Todas",
  "notifications.filterMatches": "Correspondências",
  "notifications.filterOther": "Outras",
  "notifications.newMatch": "{{count}} nova correspondência de material",
  "notifications.newMatches": "{{count}} novas correspondências de material",
  "notifications.goToDashboard": "Ir para o painel",
  "notifications.matchDashboard": "Mostrar painel de Material Matching",
  "notifications.justNow": "agora mesmo",
  "notifications.minutesAgo": "há {{count}} min",
  "notifications.hoursAgo": "há {{count}} h",
  "notifications.daysAgo": "há {{count}} d",
  "notifications.site": "Local",
  "notifications.typeMatch": "Correspondência",
  "notifications.typeApproval": "Correspondência de aprovação",
  "notifications.typeRequest": "Pedido",
  "notifications.typeEscalation": "Escalação",
  "notifications.typeLogistics": "Logística",
  "notifications.typeInfo": "Info",
  "partners.heroTitle": "Comprar. Vender. Reutilizar. Materiais excedentes — com inteligência.",
  "partners.heroSubtitle": "Junte-se ao principal marketplace de excedentes de embalagens. Acesse materiais verificados dos melhores fabricantes.",
  "partners.ctaRegister": "Registrar como parceiro",
  "partners.ctaBrowse": "Explorar materiais",
  "partners.trust1": "Registro gratuito",
  "partners.trust2": "Fornecedores verificados",
  "partners.trust3": "Sem compromisso",
  "partners.howItWorksLabel": "Processo",
  "partners.howItWorksTitle": "Como funciona",
  "partners.howItWorksSubtitle": "Três passos simples para começar a economizar.",
  "partners.step1Title": "Registrar",
  "partners.step1Desc": "Crie sua conta empresarial em minutos.",
  "partners.step2Title": "Explorar",
  "partners.step2Desc": "Pesquise milhares de materiais excedentes verificados.",
  "partners.step3Title": "Solicitar",
  "partners.step3Desc": "Envie uma solicitação diretamente ao fornecedor.",
  "partners.benefitsTitle": "Por que escolher Surplify",
  "partners.benefit1Title": "Economize até 40%",
  "partners.benefit1Desc": "Acesse materiais excedentes a uma fração do custo original.",
  "partners.benefit2Title": "Qualidade verificada",
  "partners.benefit2Desc": "Cada anúncio inclui dados do fabricante e relatórios de condição.",
  "partners.benefit3Title": "Impacto ESG",
  "partners.benefit3Desc": "Cada compra reduz emissões de CO2.",
  "partners.trustTitle": "Confiado por líderes do setor",
  "partners.trustSubtitle": "Empresas em toda a Europa confiam na Surplify",
  "partners.trustUsers": "50+ empresas",
  "partners.trustStat1": "40%",
  "partners.trustStat1Label": "Economia média nos custos",
  "partners.trustStat2": "500+",
  "partners.trustStat2Label": "Anúncios verificados",
  "partners.trustStat3": "50+",
  "partners.trustStat3Label": "Empresas parceiras ativas",
  "partners.ctaFinalTitle": "Pronto para economizar?",
  "partners.ctaFinalDesc": "Junte-se a centenas de empresas que já usam a Surplify.",
  "partners.ctaFinalRegister": "Começar gratuitamente",
  "partners.noCredit": "Sem cartão de crédito. Registro gratuito.",
  "demo.badge": "Agendar demo",
  "demo.ctaHero": "Agendar demo",
  "demo.title": "Veja o Surplify em ação",
  "demo.subtitle": "Agende uma demo gratuita e personalizada com nossa equipe.",
  "demo.point1": "Tour ao vivo pela plataforma",
  "demo.point2": "Adaptado ao seu setor e necessidades",
  "demo.point3": "Sem compromisso — totalmente grátis",
  "demo.name": "Nome",
  "demo.namePlaceholder": "Seu nome completo",
  "demo.email": "Email comercial",
  "demo.emailPlaceholder": "nome@empresa.com.br",
  "demo.company": "Empresa",
  "demo.companyPlaceholder": "Nome da sua empresa",
  "demo.phone": "Telefone (opcional)",
  "demo.phonePlaceholder": "+55 ...",
  "demo.message": "Mensagem (opcional)",
  "demo.messagePlaceholder": "Conte-nos sobre suas necessidades...",
  "demo.submit": "Solicitar demo",
  "demo.sending": "Enviando...",
  "demo.privacy": "Respeitamos sua privacidade. Seus dados serão usados apenas para contactá-lo sobre sua solicitação.",
  "demo.requiredFields": "Preencha todos os campos obrigatórios.",
  "demo.successToast": "Solicitação de demo enviada com sucesso!",
  "demo.errorToast": "Falha ao enviar. Tente novamente.",
  "demo.successTitle": "Obrigado!",
  "demo.successDesc": "Sua solicitação foi recebida. Nossa equipe entrará em contato em 24 horas.",
  "onboarding.step": "Passo",
  "onboarding.of": "de",
  "onboarding.skip": "Pular por agora",
  "onboarding.next": "Próximo",
  "onboarding.finish": "Começar",
  "onboarding.restartTour": "Reiniciar o tour",
  "onboarding.step1Title": "Bem-vindo ao Surplify",
  "onboarding.step1Desc": "Surplify é o principal marketplace de excedentes de embalagens.",
  "onboarding.step1Points": ["Milhares de materiais verificados", "Economize até 40%", "Rastreamento ESG automático"],
  "onboarding.step2Title": "Seu perfil empresarial",
  "onboarding.step2Desc": "Seu perfil representa sua empresa na plataforma.",
  "onboarding.step2Points": ["Adicione logo e descrição", "Verifique seus dados de contato", "Configure preferências"],
  "onboarding.step3Title": "Encontrar materiais",
  "onboarding.step3Desc": "Use a busca avançada para encontrar exatamente o que precisa.",
  "onboarding.step3Points": ["Busque por fabricante ou número do artigo", "Filtre por categoria e país", "Salve na sua lista de favoritos"],
  "onboarding.step4Title": "Solicitar materiais",
  "onboarding.step4Desc": "Envie uma solicitação diretamente ao fornecedor.",
  "onboarding.step4Points": ["Indique a quantidade necessária", "Adicione uma mensagem", "Acompanhe o status em tempo real"],
  "admin.addCompany": "Adicionar empresa",
  "admin.addGroup": "Adicionar grupo",
  "admin.addSite": "Adicionar local",
  "admin.approvalRequired": "Aprovacao necessaria",
  "admin.approvalRequiredDesc": "Exigir aprovacao do gerente para solicitacoes",
  "admin.approve": "Aprovar",
  "admin.approveCompany": "Aprovar",
  "admin.auditAction": "Acao",
  "admin.auditAll": "Todos",
  "admin.auditChanges": "Alteracoes",
  "admin.auditEntity": "Entidade",
  "admin.auditFilterAction": "Filtrar por acao",
  "admin.auditFilterEntity": "Filtrar por entidade",
  "admin.auditLog": "Registro de auditoria",
  "admin.auditLogDesc": "Historico completo de todas as alteracoes do sistema",
  "admin.auditNextPage": "Proximo",
  "admin.auditNoEntries": "Nenhum registro de auditoria encontrado.",
  "admin.auditPage": "Pagina {{page}} de {{pages}}",
  "admin.auditPrevPage": "Anterior",
  "admin.auditTimestamp": "Data e hora",
  "admin.auditUser": "Usuario",
  "admin.autoApproval": "Aprovacao automatica",
  "admin.categories": "Categorias",
  "admin.city": "Cidade",
  "admin.companyApproved": "Empresa aprovada",
  "admin.companyCreated": "Empresa criada com sucesso",
  "admin.companyFailed": "Falha ao atualizar a empresa",
  "admin.companyName": "Nome da empresa",
  "admin.companyNamePlaceholder": "ex. PackPro GmbH",
  "admin.companyRejected": "Empresa rejeitada",
  "admin.contactEmail": "E-mail de contato",
  "admin.contactName": "Nome do contato",
  "admin.contactPhone": "Telefone de contato",
  "admin.country": "Pais",
  "admin.defaultImage": "Imagem padrao",
  "admin.docsBlocked": "Docs bloqueados",
  "admin.domainsAllowed": "Dominios permitidos",
  "admin.emailsFailed": "E-mails falhados",
  "admin.emailsSent": "E-mails enviados",
  "admin.emailsSkipped": "Ignorados",
  "admin.escalatedRequests": "Solicitacoes escaladas",
  "admin.escalationDays": "Dias de escalacao",
  "admin.escalationDaysDesc": "Dias antes das notificacoes de escalacao",
  "admin.externalBlocked": "Externo bloqueado",
  "admin.externalCompanies": "Empresas externas",
  "admin.externalCompaniesDesc": "Gerenciar registros e aprovacoes de empresas externas",
  "admin.externalEnabled": "Publicacao externa habilitada",
  "admin.externalEnabledDesc": "Permitir que os materiais sejam visiveis externamente",
  "admin.externalOpen": "Externo aberto",
  "admin.groupAdmin": "Admin de grupo",
  "admin.groupAdminDesc": "Gerenciar estrategia e usuarios do seu grupo empresarial",
  "admin.groupName": "Nome do grupo",
  "admin.groupNamePlaceholder": "ex. Acme Packaging Group",
  "admin.groupUsersDesc": "Gerenciar e aprovar usuarios dentro do seu grupo empresarial",
  "admin.guide": "Guia",
  "admin.guideAudit": "Registro de auditoria",
  "admin.guideAuditText": "O registro de auditoria fornece um historico completo de todas as alteracoes do sistema para conformidade e rastreabilidade.",
  "admin.guideAuditTip": "O registro de auditoria e imutavel e nao pode ser editado ou excluido.",
  "admin.guideCategories": "Gerenciamento de categorias",
  "admin.guideCategoriesText": "As categorias organizam os materiais em uma estrutura de arvore hierarquica.",
  "admin.guideCategoriesTip": "As categorias excluidas sao desativadas (exclusao suave). Os materiais atribuidos anteriormente permanecem acessiveis.",
  "admin.guideDashboard": "Dashboard e Relatorios",
  "admin.guideDashboardText": "O Dashboard fornece KPIs em tempo real sobre idade do inventario, atividade de transferencias, metricas de sustentabilidade e valor em risco.",
  "admin.guideDashboardTip": "O relatorio de sustentabilidade inclui estimativas de economia de CO2 baseadas nas quantidades de materiais redistribuidos.",
  "admin.guideDesc": "Guia completo para configuracao da plataforma, governanca e gerenciamento diario",
  "admin.guideExternal": "Empresas externas",
  "admin.guideExternalText": "Empresas externas podem se autoregistrar na plataforma. Os administradores revisam solicitacoes e as aprovam ou rejeitam.",
  "admin.guideExternalTip": "Ao aprovar ou rejeitar, uma notificacao por e-mail e enviada automaticamente ao contato da empresa.",
  "admin.guideGettingStarted": "Primeiros passos",
  "admin.guideGettingStartedText": "Bem-vindo ao Surplify! Esta plataforma ajuda sua organizacao a reduzir o capital de giro redistribuindo materias-primas de rotacao lenta entre locais.",
  "admin.guideGettingStartedTip": "Use o botao 'Carregar dados de exemplo' para preencher categorias e materiais de demonstracao.",
  "admin.guideImport": "Importacao/Exportacao Excel",
  "admin.guideImportText": "A pagina de importacao suporta gerenciamento em massa de materiais via upload de arquivos Excel.",
  "admin.guideImportTip": "Use o modo 'Apenas enriquecer' para atualizacoes incrementais sem sobrescrever dados existentes.",
  "admin.guideNotifications": "Notificacoes por e-mail",
  "admin.guideNotificationsText": "A plataforma envia notificacoes automaticas por e-mail para solicitacoes escaladas, novas solicitacoes de materiais e mudancas de status de empresas externas.",
  "admin.guideNotificationsTip": "Os e-mails de escalacao sao disparados quando as solicitacoes pendentes ultrapassam o limite de 'Dias de escalacao' configurado.",
  "admin.guideScenarios": "Configuracao de cenarios",
  "admin.guideScenariosText": "Os cenarios controlam as regras de governanca para a redistribuicao de materiais.",
  "admin.guideScenariosTip": "O dashboard de impacto do cenario mostra efeitos em tempo real das configuracoes atuais.",
  "admin.guideTitle": "Guia de administracao",
  "admin.guideVotes.title": "Secoes do guia com pior avaliacao",
  "admin.guideVotes.desc": "As 5 secoes com o feedback mais negativo dos utilizadores - vale a pena rever.",
  "admin.guideVotes.empty": "Ainda nao ha avaliacoes.",
  "admin.guideVotes.loading": "A carregar avaliacoes…",
  "admin.guideVotes.unknownSection": "Secao desconhecida",
  "admin.guideVotes.score": "Pontuacao liquida (gosto − nao gosto)",
  "admin.guideUsers": "Gerenciamento de usuarios",
  "admin.guideUsersText": "Os usuarios se registram na plataforma e devem ser aprovados antes de acessar dados sensiveis.",
  "admin.guideUsersTip": "Revogar um usuario nao exclui sua conta. Pode ser re-aprovado a qualquer momento.",
  "admin.houseNumber": "Numero",
  "admin.industry": "Setor",
  "admin.internalWindow": "Janela interna (dias)",
  "admin.internalWindowDesc": "Dias em que os artigos sao visiveis apenas internamente",
  "admin.internalWindowItems": "Na janela interna",
  "admin.lastCheck": "Ultima verificacao",
  "admin.legalPageContent": "Conteudo da pagina (HTML)",
  "admin.legalPageTitle": "Titulo da pagina",
  "admin.legalPages": "Paginas legais",
  "admin.legalPagesDesc": "Editar paginas de suporte, termos, aviso legal, privacidade",
  "admin.legalPreview": "Pre-visualizacao",
  "admin.loadSettings": "Carregar configuracoes",
  "admin.manualApproval": "Aprovacao manual",
  "admin.masterData": "Dados mestres",
  "admin.materialApprovals": "Aprovacoes de materiais",
  "admin.materialApprovalsDesc": "Revisar e aprovar listagens de materiais externos",
  "admin.mode.aggressive_cash": "Agressivo (Cash)",
  "admin.mode.aggressive_cashDesc": "Janelas mais curtas, liquidacao mais rapida",
  "admin.mode.balanced": "Equilibrado",
  "admin.mode.balancedDesc": "Regras de governanca padrao",
  "admin.mode.conservative": "Conservador",
  "admin.mode.conservativeDesc": "Janelas mais longas, mais aprovacoes",
  "admin.mode.crisis_mode": "Modo crise",
  "admin.mode.crisis_modeDesc": "Modo de eliminacao de emergencia",
  "admin.ndaNotSigned": "NDA pendente",
  "admin.ndaSigned": "NDA assinado",
  "admin.noCompanies": "Nenhuma empresa externa registrada.",
  "admin.noGroups": "Nenhum grupo encontrado. Adicione seu primeiro grupo.",
  "admin.noNotifications": "Nenhuma notificacao enviada",
  "admin.noPendingMaterials": "Nenhuma aprovacao de material pendente",
  "admin.noSites": "Nenhum local encontrado. Adicione sua primeira sede.",
  "admin.noSitesNoGroup": "Crie primeiro um grupo empresarial antes de adicionar locais.",
  "admin.notifDaysPending": "Dias pendentes",
  "admin.notifExtApproved": "Aprovado",
  "admin.notifExtCompany": "Empresa externa",
  "admin.notifExtRejected": "Rejeitado",
  "admin.notifMaterial": "Material",
  "admin.notifOwner": "Proprietario",
  "admin.notifRecipients": "Destinatarios",
  "admin.notifRequestedQty": "Quantidade solicitada",
  "admin.notifRequester": "Solicitante",
  "admin.notifSentAt": "Enviado em",
  "admin.notifSite": "Local",
  "admin.notifStatus": "Status",
  "admin.notifTypeEscalation": "Escalacao",
  "admin.notifTypeExtCompany": "Emp. externas",
  "admin.notifTypeNewRequest": "Nova solicitacao",
  "admin.notifications": "Notificacoes",
  "admin.notificationsDesc": "Historico de e-mails de escalacao e gerenciamento",
  "admin.notificationsTitle": "Notificacoes por e-mail",
  "admin.orgDesc": "Gerenciar organizacoes inquilinas",
  "admin.orgTitle": "Grupos empresariais",
  "admin.organizations": "Organizacoes",
  "admin.platformAdminDesc": "Administracao da plataforma - gerenciar todos os grupos, locais e usuarios",
  "admin.postalCode": "CEP",
  "admin.reject": "Rejeitar",
  "admin.rejectCompany": "Rejeitar",
  "admin.saveSettings": "Salvar configuracoes",
  "admin.scenarioImpact": "Impacto do cenario",
  "admin.scenarioImpactDesc": "Impacto em tempo real das configuracoes atuais",
  "admin.scenarioMode": "Modo de cenario",
  "admin.scenarios": "Cenarios",
  "admin.scenariosDesc": "Configurar regras de governanca e fluxos de aprovacao",
  "admin.scenariosTitle": "Configuracao de cenarios",
  "admin.seedData": "Carregar dados de exemplo",
  "admin.selectGroup": "Selecionar grupo empresarial",
  "admin.selectGroupPlaceholder": "Escolher um grupo...",
  "admin.settingsFailed": "Falha ao salvar as configuracoes",
  "admin.settingsSaved": "Configuracoes salvas com sucesso",
  "admin.sites": "Locais",
  "admin.sitesDesc": "Gerenciar localizacoes de armazem",
  "admin.sitesTitle": "Locais",
  "admin.street": "Rua",
  "admin.strictDocs": "Documentacao rigorosa",
  "admin.strictDocsActive": "Documentacao rigorosa ativa",
  "admin.strictDocsDesc": "Bloquear importacoes sem fichas tecnicas",
  "admin.submittedBy": "Enviado por",
  "admin.title": "Administracao",
  "admin.totalNotifications": "Total de notificacoes",
  "admin.triggerCheck": "Verificar agora",
  "admin.triggerCheckDesc": "Verificar manualmente solicitacoes escaladas e enviar notificacoes",
  "admin.triggerCheckFailed": "Falha na verificacao de escalacao",
  "admin.triggerCheckSuccess": "Verificacao de escalacao concluida",
  "admin.uploadDefaultImage": "Carregar imagem",
  "admin.vatId": "NIF/CNPJ",
  "admin.website": "Site web",
  "auth.companyGroup": "Grupo empresarial",
  "auth.selectCompanyGroup": "Selecione seu grupo...",
  "auth.selectSite": "Selecione sua fabrica...",
  "auth.site": "Fabrica / Local",
  "bulk.browse": "Procurar arquivos",
  "bulk.col.article_number": "No. de artigo",
  "bulk.col.manufacturer_name": "Fabricante",
  "bulk.col.manufacturer_part_number": "No. de peca",
  "bulk.col.notes_internal": "Notas",
  "bulk.col.number_of_rolls": "Rolos",
  "bulk.col.quantity": "Quantidade",
  "bulk.col.uom": "UdM",
  "bulk.created": "Criados",
  "bulk.downloadTemplate": "Baixar modelo",
  "bulk.dropHint": "Arraste e solte seu arquivo Excel/CSV aqui",
  "bulk.duplicates": "Existente (Atualizar)",
  "bulk.enriched": "Enriquecidos",
  "bulk.errors": "Erros",
  "bulk.executeImport": "Importar {{count}} linhas",
  "bulk.importComplete": "Importacao concluida!",
  "bulk.importError": "Falha na importacao",
  "bulk.importMode": "Modo de importacao para duplicatas",
  "bulk.importMore": "Importar mais",
  "bulk.importing": "Importando...",
  "bulk.invalidFile": "Formato de arquivo invalido. Use .xlsx, .xls ou .csv",
  "bulk.modeEnrich": "Enriquecer",
  "bulk.modeEnrichDesc": "Preencher apenas campos vazios, manter existentes",
  "bulk.modeOverwrite": "Sobrescrever",
  "bulk.modeOverwriteDesc": "Substituir todos os campos com valores importados",
  "bulk.moreRows": "mais linhas",
  "bulk.newItems": "Novos itens",
  "bulk.parseError": "Falha ao analisar o arquivo",
  "bulk.rejected": "Rejeitados",
  "bulk.rowError": "Linha {{row}}",
  "bulk.rows": "Linhas",
  "bulk.rowsLoaded": "{{count}} linhas carregadas",
  "bulk.subtitle": "Importar varios materiais de uma vez via Excel/CSV",
  "bulk.templateDownloaded": "Modelo baixado",
  "bulk.templateError": "Falha ao baixar o modelo",
  "bulk.title": "Upload em massa",
  "bulk.updated": "Atualizados",
  "bulk.valid": "Valido",
  "bulk.validate": "Validar dados",
  "bulk.validateError": "Falha na validacao",
  "bulk.validating": "Validando...",
  "bulk.validationErrors": "Erros de validacao",
  "common.deleting": "Excluindo...",
  "create.addDocument": "Adicionar documento PDF",
  "create.techSpec": "Ficha técnica",
  "create.techSpecHint": "É necessária pelo menos uma ficha técnica (PDF). Os compradores precisam dela para avaliar o material.",
  "create.techSpecRequired": "Obrigatório",
  "create.addTechSpec": "Carregar ficha técnica (PDF)",
  "create.techSpecRequiredError": "Carregue uma ficha técnica (PDF) antes de salvar.",
  "create.addPhoto": "Foto",
  "create.documents": "Documentos (PDF)",
  "create.erpArticleNumber": "Numero de artigo ERP",
  "create.materialIndex": "Indice do material",
  "create.photos": "Fotos",
  "dashboard.agingAutoCalculated": "O envelhecimento e calculado automaticamente a partir da data de producao",
  "dashboard.categoryBreakdown": "Detalhamento por categoria",
  "dashboard.categoryBreakdownDesc": "Principais categorias por valor em risco",
  "dashboard.items": "Artigos",
  "dashboard.kEUR": "kEUR",
  "dashboard.skus": "SKUs",
  "dashboard.topRisk": "Materiais de maior risco",
  "dashboard.topRiskDesc": "Materiais de maior valor (rotacao lenta/nula)",
  "dashboard.totalValue": "Valor total do inventario",
  "dashboard.totalValueDesc": "Valor contabil total de todos os SKUs ativos",
  "dashboard.valueAtRisk": "Valor em risco",
  "dashboard.valueAtRiskDesc": "Valor contabil do estoque de rotacao lenta/nula",
  "ext.alreadyRegistered": "Ja registrado?",
  "ext.backStep": "Voltar",
  "ext.chooseRegistrationType": "Como deseja se registrar?",
  "ext.companyInfo": "Dados da empresa",
  "ext.confirmPassword": "Confirmar senha",
  "ext.continue": "Continuar",
  "ext.createFirstListing": "Publicar primeiro material",
  "ext.createListing": "Publicar material",
  "ext.deleteConfirmDesc": "Tem certeza de que deseja excluir este material? Esta acao nao pode ser desfeita.",
  "ext.deleteConfirmTitle": "Excluir material?",
  "ext.fillRequired": "Preencha todos os campos obrigatorios",
  "ext.groupName": "Nome do grupo",
  "ext.internalUser": "Usuario interno?",
  "ext.linkedUsers": "Usuarios vinculados",
  "ext.materialDeleted": "Material excluido",
  "ext.myCompany": "Minha empresa",
  "ext.myListings": "Meus anuncios",
  "ext.nextStep": "Proximo: Conta de usuario",
  "ext.noCompanyLinked": "Nenhuma empresa externa vinculada a sua conta",
  "ext.noLinkedUsers": "Nenhum usuario vinculado",
  "ext.noListings": "Nenhum material publicado",
  "ext.noListingsDesc": "Publique seu primeiro material para oferece-lo no mercado.",
  "ext.passwordMismatch": "As senhas nao coincidem",
  "ext.passwordTooShort": "A senha deve ter pelo menos 6 caracteres",
  "ext.pendingMessage": "Seu registro esta em analise. Uma vez aprovado, voce podera oferecer materiais no mercado.",
  "ext.pendingTitle": "Aprovacao pendente",
  "ext.portalTitle": "Portal da empresa",
  "ext.registerAsExternal": "Registrar-se como empresa externa",
  "ext.registerAsGroup": "Como grupo",
  "ext.registerAsGroupDesc": "Empresa com multiplas fabricas/locais",
  "ext.registerAsSite": "Como local individual",
  "ext.registerAsSiteDesc": "Local unico sem grupo pai",
  "ext.registerDesc": "Registre sua empresa para oferecer materiais no mercado.",
  "ext.registerGroupDesc": "Registre seu grupo para participar do mercado com multiplos locais.",
  "ext.registerInternal": "Registrar-se aqui",
  "ext.registerSiteDesc": "Registre seu local como sede unica no mercado.",
  "ext.registerTitle": "Registrar-se como empresa externa",
  "ext.registrationPending": "Sua empresa esta em analise. Voce sera notificado quando seu acesso for ativado.",
  "ext.registrationSuccess": "Registro concluido!",
  "ext.registrationType": "Tipo",
  "ext.rejectedMessage": "Infelizmente seu registro foi rejeitado. Entre em contato com o suporte para mais informacoes.",
  "ext.rejectedTitle": "Registro rejeitado",
  "ext.siteName": "Nome do local",
  "ext.submitRegistration": "Enviar registro",
  "ext.userAccount": "Conta de usuario",
  "filter.advancedFilters": "Filtros avancados",
  "filter.ageBucket": "Idade do estoque",
  "filter.age_0_90": "< 3 meses",
  "filter.age_181_360": "6-12 meses",
  "filter.age_91_180": "3-6 meses",
  "filter.age_gt_360": "> 12 meses",
  "filter.basicFilters": "Filtros",
  "filter.both": "Ambos",
  "filter.certifications": "Certificacoes",
  "filter.clearAll": "Limpar tudo",
  "filter.clearAllFilters": "Limpar todos os filtros",
  "filter.clearFilters": "Limpar filtros",
  "filter.complianceFlag": "Indicador de conformidade",
  "filter.compliant": "Conforme",
  "filter.core": "Nucleo",
  "filter.coreDiameter": "Diametro do nucleo",
  "filter.customerSpecific": "Especifico do cliente",
  "filter.filters": "Filtros",
  "filter.materialProperties": "Propriedades do material",
  "filter.max": "Max",
  "filter.min": "Min",
  "filter.minQuantity": "Quantidade minima",
  "filter.no": "Nao",
  "filter.qty": "Qtd.",
  "filter.quantity": "Quantidade",
  "filter.stockDetails": "Detalhes do estoque",
  "filter.technicalSpecs": "Especificacoes tecnicas",
  "filter.thickness": "Espessura",
  "filter.thicknessRange": "Faixa de espessura",
  "filter.widthRange": "Faixa de largura",
  "filter.yes": "Sim",
  "group.allSites": "Todos os locais",
  "group.filterSite": "Filtrar por local",
  "group.filterStatus": "Filtrar por status",
  "group.noMaterials": "Nenhum material encontrado no seu grupo",
  "group.otherSite": "Outro local",
  "group.ownMaterial": "Material proprio",
  "group.sites": "Locais",
  "group.skuCount": "{{count}} SKUs",
  "group.subtitle": "Todos os materiais em todos os locais do seu grupo empresarial",
  "group.title": "Materiais do meu grupo",
  "group.totalValue": "Valor total",
  "masterData.applied": "Dados mestres aplicados",
  "masterData.appliedLabel": "Dados mestres aplicados",
  "masterData.matchesFound": "Dados mestres encontrados",
  "masterData.searchPlaceholder": "Buscar por fornecedor, no. de artigo...",
  "myMaterials.allStatuses": "Todos os status",
  "myMaterials.archive": "Arquivar",
  "myMaterials.archiveDesc": "O material sera arquivado e nao sera mais visivel no mercado.",
  "myMaterials.archiveTitle": "Arquivar material?",
  "myMaterials.archived": "Material arquivado",
  "myMaterials.articles": "artigos",
  "myMaterials.bulkUpload": "Upload em massa",
  "myMaterials.deleteDesc": "O material e todo o inventario associado serao excluidos permanentemente.",
  "myMaterials.deleteTitle": "Excluir material?",
  "myMaterials.deleted": "Material excluido",
  "myMaterials.empty": "Nenhum artigo encontrado",
  "myMaterials.emptyDesc": "Nenhum artigo foi publicado no seu local ainda.",
  "myMaterials.newArticle": "Novo artigo",
  "myMaterials.noSite": "Sua conta nao tem um local atribuido.",
  "myMaterials.noSiteDesc": "Entre em contato com um administrador para ser atribuido a um local.",
  "myMaterials.noSiteTitle": "Nenhum local atribuido",
  "myMaterials.quantity": "Qtd.",
  "myMaterials.searchPlaceholder": "Buscar artigos...",
  "myMaterials.statusArchived": "Arquivado",
  "myMaterials.title": "Meus materiais do local",
  "myMaterials.value": "Valor",
  "myMaterials.you": "Voce",
  "nav.myGroup": "Meu grupo",
  "nav.myMaterials": "Meus artigos",
  "nav.scenario": "Cenario",
  "pagination.next": "Proximo",
  "pagination.previous": "Anterior",
  "preset.applied": "Predefinicao \"{name}\" aplicada",
  "preset.applyFailed": "Falha ao aplicar a predefinicao",
  "preset.delete": "Excluir",
  "preset.deleteConfirm": "Excluir predefinicao?",
  "preset.deleteDescription": "A predefinicao \"{name}\" sera excluida permanentemente.",
  "preset.deleteFailed": "Falha ao excluir a predefinicao",
  "preset.deleted": "Predefinicao excluida",
  "preset.filters": "filtros",
  "preset.filtersWillBeSaved": "filtros serao salvos",
  "preset.maxReached": "Maximo alcancado",
  "preset.name": "Nome da predefinicao",
  "preset.namePlaceholder": "ex. Filmes FSC > 100mm",
  "preset.nameRequired": "Insira um nome para a predefinicao",
  "preset.newName": "Novo nome",
  "preset.noFiltersToSave": "Nenhum filtro ativo para salvar",
  "preset.noPresets": "Nenhuma predefinicao salva",
  "preset.presets": "Predefinicoes",
  "preset.rename": "Renomear",
  "preset.renameFailed": "Falha ao renomear a predefinicao",
  "preset.renamePreset": "Renomear predefinicao",
  "preset.renamed": "Predefinicao renomeada",
  "preset.saveCurrentFilters": "Salvar filtros atuais",
  "preset.saveDescription": "De um nome a sua combinacao de filtros para aplica-la rapidamente depois.",
  "preset.saveFailed": "Falha ao salvar a predefinicao",
  "preset.saveHint": "Aplique filtros e salve-os",
  "preset.savePreset": "Salvar predefinicao de filtro",
  "preset.saved": "Predefinicao salva",
  "preset.used": "predefinicoes usadas",
  "scenario.applyChanges": "Aplicar alteracoes",
  "scenario.autoApproved": "Auto-aprovado",
  "scenario.blocked": "Bloqueado",
  "scenario.currentSettings": "Configuracoes atuais",
  "scenario.docsBlocked": "Docs bloqueados",
  "scenario.enabled": "Habilitado",
  "scenario.escalatedRequests": "Solicitacoes escaladas",
  "scenario.externalAccess": "Acesso externo",
  "scenario.internalWindow": "Na janela interna",
  "scenario.itemsAtRisk": "Artigos em risco",
  "scenario.noChanges": "Ajuste as configuracoes e clique em 'Visualizar' para ver o efeito",
  "scenario.pendingRequests": "Solicitacoes pendentes",
  "scenario.preview": "Visualizar impacto",
  "scenario.previewResult": "Impacto projetado",
  "scenario.subtitle": "Visualizacao do impacto de mudancas de governanca antes de aplica-las",
  "scenario.title": "Analise What-If de cenarios",
  "scenario.valueAtRisk": "Valor em risco",
  "scenario.whatIf": "Visualizacao What-If",
  "search.allMaterials": "Todos os materiais",
  "search.filtering": "Filtrando...",
  "search.materialsFound": "materiais encontrados",
  "search.resultsFor": "Resultados para",
  "search.tryAdjusting": "Tente ajustar seus filtros ou termos de busca",
  "sort.newestFirst": "Mais recentes",
  "sort.oldestFirst": "Mais antigos",
  "sort.priceHighLow": "Preco: Decrescente",
  "sort.priceLowHigh": "Preco: Crescente",
  "sort.quantityHighLow": "Quantidade: Decrescente",
  "sort.sortBy": "Ordenar por",
  "status.archived": "Arquivado",
  "status.pendingApproval": "Aprovacao pendente",
  "admin.guideAuditSteps": ["Navegue ate Admin > Registro de auditoria.", "Use o filtro de tipo de entidade.", "Use o filtro de acao.", "Expanda as 'Alteracoes' para ver dados modificados.", "Use a paginacao para navegar pelo historico."],
  "admin.guideCategoriesSteps": ["Navegue ate Admin > Categorias para ver a arvore.", "Clique em 'Adicionar categoria' para uma categoria principal.", "Clique em '+' em qualquer categoria para adicionar subcategoria.", "Edite ou exclua categorias existentes com os botoes de acao.", "As categorias podem ser reordenadas pelo campo de ordem."],
  "admin.guideDashboardSteps": ["Navegue ate o Dashboard.", "Confira os KPIs globais.", "Use o filtro de local para metricas especificas.", "Baixe relatorios PDF de sustentabilidade.", "Monitore materiais em risco."],
  "admin.guideExternalSteps": ["Empresas externas se registram pelo formulario publico (/register-external).", "Navegue ate Admin > Empresas externas para revisar solicitacoes.", "Clique em 'Aprovar' para ativar a empresa.", "Clique em 'Rejeitar' para negar o acesso.", "Empresas aprovadas podem listar seus materiais.", "Clique em uma linha da empresa para ver usuarios vinculados."],
  "admin.guideGettingStartedSteps": ["Crie seu grupo empresarial e pelo menos um local em Admin > Organizacoes e Locais.", "Carregue dados iniciais com o botao 'Carregar dados' (apenas uma vez para demo/teste).", "Convide usuarios compartilhando o link de registro. Aprove novos usuarios em Admin > Usuarios.", "Configure seu modo de governanca preferido em Admin > Cenarios.", "Carregue materiais pela pagina de importacao ou crie-os individualmente."],
  "admin.guideImportSteps": ["Navegue ate a pagina de importacao.", "Baixe o modelo Excel.", "Preencha seus dados e carregue o arquivo.", "Verifique os resultados da validacao.", "Escolha um modo de importacao.", "Execute a importacao."],
  "admin.guideNotificationsSteps": ["Navegue ate Admin > Notificacoes.", "Confira as estatisticas: total enviado, falhado e por tipo.", "Clique em 'Verificar agora' para executar a verificacao de escalacao.", "Navegue pelo historico de notificacoes.", "As notificacoes requerem uma chave API Resend configurada."],
  "admin.guideScenariosSteps": ["Selecione um modo: Equilibrado (padrao), Conservador, Agressivo (Cash) ou Modo Crise.", "Ajuste a 'Janela interna' (dias em que materiais ficam apenas internos).", "Defina os 'Dias de escalacao' para notificacoes automaticas.", "Ative/desative 'Externo habilitado' para controlar o acesso externo.", "Ative/desative 'Aprovacao necessaria' para aprovacao automatica ou manual.", "Ative 'Documentacao rigorosa' para bloquear artigos sem fichas tecnicas."],
  "admin.guideUsersSteps": ["Navegue ate Admin > Usuarios para ver todos os registrados.", "Usuarios pendentes sao marcados com indicador amarelo.", "Clique em 'Aprovar' para conceder acesso completo ao mercado.", "Clique em 'Revogar' para desativar temporariamente o acesso.", "Administradores sao aprovados automaticamente ao se registrar."],
  "admin.pendingRequests": "Solicitacoes pendentes",
  "app.subtitle": "tornar o excedente util",
  "auth.loginError": "E-mail ou senha invalidos",
  "auth.loginSuccess": "Login realizado com sucesso!",
  "auth.passwordTooShort": "A senha deve ter pelo menos 6 caracteres",
  "auth.passwordsNoMatch": "As senhas nao coincidem",
  "auth.registerError": "Falha no registro",
  "filter.allCategories": "Todas as categorias",
  "home.loginRequired": "Faca login para usar a lista de favoritos",
  "home.materialsCount": "materiais",
  "home.noMaterials": "Nenhum material encontrado.",
  "home.seedDescription": "Voce pode carregar dados de exemplo para comecar.",
  "home.seedError": "Erro ao carregar os dados",
  "home.seedSuccess": "Dados carregados com sucesso! Atualizando...",
  "home.seeding": "Carregando...",
  "home.watchlistError": "Erro ao atualizar a lista de favoritos",
  "sort.dateAdded": "Data de adicao",
  "sort.price": "Preco",
  "sort.quantity": "Quantidade",
  "admin.platformSettings": "Configurações",
  "admin.resendEmail": "Reenviar e-mail",
  "guide.title": "Ajuda & FAQ",
  "guide.subtitle": "Manual do usuário e respostas a perguntas frequentes",
  "guide.searchPlaceholder": "Buscar no manual e FAQ...",
  "guide.tabGuide": "Manual do usuário",
  "guide.tabFaq": "FAQ",
  "guide.noResults": "Sem resultados para",
  "guide.topic": "tópico",
  "guide.topics": "tópicos",
  "home.hero.badge": "B2B Circular · Impressão e Embalagem",
  "home.hero.verified": "Verificado UE",
  "home.hero.headlineA": "Reutilizar.",
  "home.hero.headlineB": "Reparar.",
  "home.hero.headlineC": "Redistribuir.",
  "home.hero.subtitle": "Surplify é o marketplace B2B circular para a indústria de impressão e embalagem — dando uma segunda vida a materiais excedentes, peças sobressalentes e máquinas usadas. Cada transação evita produção virgem, economiza CO₂ e preserva o capital de giro.",
  "home.hero.impactPrefix": "Economizado em conjunto até agora:",
  "home.hero.impactSuffix": "de CO₂",
  "home.hero.searchPlaceholder": "Fabricante, nº de peça, material, modelo…",
  "home.hero.searchBtn": "Pesquisar",
  "home.hero.verticalMaterials": "Excedente",
  "home.hero.verticalSpareParts": "Peças sobressalentes",
  "home.hero.verticalMachines": "Máquinas",
  "home.hero.verticalPaints": "Tintas e revestimentos",
  "home.hero.ctaPostWanted": "Publicar pedido de compra",
  "home.hero.ctaForSellers": "Para vendedores",
  "home.hero.ctaGuide": "Ajuda & guia",
  "home.hero.trustVies": "IVA verificado por EU VIES",
  "home.hero.trustCompanies": "Contas de empresa verificadas",
  "home.hero.trustCircular": "Economia circular",
  "home.newco.badge": "Novo na Surplify?",
  "home.newco.title": "A sua empresa no marketplace B2B em 3 passos",
  "home.newco.subtitle": "Material excedente, resíduos, tintas, peças sobressalentes e máquinas de impressão usadas — tudo numa só plataforma. Comece grátis, negoceie de forma justa e documente em conformidade com REACH/CLP.",
  "home.newco.step1Title": "Crie a sua empresa",
  "home.newco.step1Desc": "Nome da empresa, NIF/IVA, morada — validado por VIES",
  "home.newco.step2Title": "Crie o seu primeiro anúncio",
  "home.newco.step2Desc": "Material, tinta, peça ou máquina — preencha o formulário, pronto",
  "home.newco.step3Title": "Receba pedidos e venda",
  "home.newco.step3Desc": "Comissão apenas em transações bem-sucedidas. Sem taxas de configuração.",
  "home.newco.ctaRegister": "Registe a sua empresa agora",
  "home.newco.ctaPartners": "Para parceiros e grandes clientes",
  "home.newco.disclaimer": "Plano inicial gratuito · Não é necessário cartão de crédito · Conforme RGPD e B2B",
  "home.newco.whatYouGet": "O que recebe",
  "home.newco.freeTier": "No plano inicial gratuito",
  "home.newco.feat1Label": "4 verticais de material",
  "home.newco.feat1Sub": "Materiais · Tintas · Peças · Máquinas",
  "home.newco.feat2Label": "Anúncios ilimitados",
  "home.newco.feat2Sub": "Sem limites de quantidade no plano padrão",
  "home.newco.feat3Label": "Algoritmo de correspondência",
  "home.newco.feat3Sub": "Os pedidos dos compradores são associados automaticamente",
  "home.newco.feat4Label": "Conformidade REACH/CLP",
  "home.newco.feat4Sub": "Fichas de dados de segurança e pictogramas GHS integrados",
  "home.newco.feat5Label": "Relatórios de sustentabilidade",
  "home.newco.feat5Sub": "As poupanças de CO₂ são documentadas automaticamente",
  "home.newco.freeBadge": "Comece 100% grátis",
  "home.pillar.materials.label": "Excedente",
  "home.pillar.materials.title": "Excedentes e materiais",
  "home.pillar.materials.desc": "Filmes, papel, bobinas e semiacabados — mantidos no ciclo em vez de incinerados.",
  "home.pillar.materials.metric": "anúncios ativos",
  "home.pillar.spareParts.label": "Peças sobressalentes",
  "home.pillar.spareParts.title": "Peças sobressalentes e módulos",
  "home.pillar.spareParts.desc": "Peças OEM reutilizadas — cada componente salvo evita nova extração e produção.",
  "home.pillar.spareParts.metric": "novos",
  "home.pillar.machines.label": "Máquinas",
  "home.pillar.machines.title": "Máquinas de impressão",
  "home.pillar.machines.desc": "Prensas usadas substituem novas — até 80 % menos CO₂.",
  "home.pillar.machines.metric": "disponíveis",
  "home.pillar.paints.label": "Tintas e revestimentos",
  "home.pillar.paints.title": "Tintas, vernizes e aditivos",
  "home.pillar.paints.desc": "Tintas, vernizes e aditivos químicos excedentes — mantidos em produção em vez de descartados como resíduos perigosos.",
  "home.pillar.paints.metric": "em estoque",
  "home.sustain.liveImpact": "Impacto ao vivo",
  "home.sustain.co2": "CO₂ economizado",
  "home.sustain.redistributed": "redistribuído",
  "home.sustain.sites": "unidades",
  "home.sustain.circular": "taxa circular",
  "home.sustain.atRisk": "em risco",
  "home.machines.label": "Vertical · Máquinas",
  "home.machines.title": "Máquinas de impressão usadas, com um segundo ciclo de produção.",
  "home.machines.subtitle": "Cada prensa usada substitui uma recém-fabricada — com uma fração do CO₂ e matérias-primas. Inspeção opcional, compatibilidade verificada.",
  "home.machines.seeAll": "Todas as máquinas",
  "home.machines.emptyDesc": "Ainda não há máquinas de impressão listadas.",
  "home.machines.emptyCreate": "Criar anúncio",
  "home.spareParts.label": "Vertical · Peças sobressalentes",
  "home.spareParts.title": "Peças OEM — mantidas em circulação.",
  "home.spareParts.subtitle": "Estoque não utilizado, buffers de obsolescência, linhas desativadas. Redirecionamos peças para a produção em vez do sucateamento.",
  "home.spareParts.seeAll": "Todas as peças",
  "home.spareParts.emptyDesc": "Ainda não há peças listadas.",
  "home.spareParts.emptyCreate": "Criar primeiro anúncio",
  "home.paints.label": "Vertical · Tintas e revestimentos",
  "home.paints.title": "Tintas, vernizes e aditivos excedentes — de volta à prensa.",
  "home.paints.subtitle": "Tonalidades descontinuadas, lotes restantes, estoque retirado. Devolvemos químicos de impressão à produção em vez de pagar taxas de descarte.",
  "home.paints.seeAll": "Todas as tintas e revestimentos",
  "home.paints.emptyDesc": "Ainda não há tintas, vernizes ou aditivos listados.",
  "home.paints.emptyCreate": "Criar primeiro anúncio",
  "home.materials.label": "Vertical · Excedente",
  "home.materials.title": "Excedente e sobreprodução.",
  "home.materials.subtitle": "Estoque ao vivo de produções, esvaziamento de armazém e devoluções de qualidade — devolvido diretamente à indústria.",
  "home.trust.vies.title": "IVA UE VIES",
  "home.trust.vies.desc": "Verificação automática dos números de IVA para cada empresa registrada.",
  "home.trust.companies.title": "Empresas verificadas",
  "home.trust.companies.desc": "Apenas contas B2B verificadas têm acesso completo ao marketplace.",
  "home.trust.csv.title": "Importação CSV em massa",
  "home.trust.csv.desc": "Liste milhares de peças e materiais em um único upload.",
  "home.trust.circular.title": "Economia circular",
  "home.trust.circular.desc": "Cada redistribuição evita produção virgem e reduz as emissões de escopo 3.",
  "machine.card.label": "Máquina de impressão",
  "machine.card.year": "Ano",
  "machine.card.hours": "h",
  "machine.card.width": "Largura",
  "machine.card.price": "Preço",
  "sparePart.card.label": "Peça sobressalente",
  "sparePart.card.compatible": "Compatível:",
  "sparePart.card.single": "Item único"
};

export default pt;
